import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { map, Observable } from 'rxjs';
import { IPostItem, IPostParams, IPostPayload, IPostResponseModel } from '@pkp-g/core';

/**
 * API постов (ADR 0008, срез 02): CRUD + перенос полосы между постами.
 * Удаление поста с полосами запрещено бэкендом (409 → понятная ошибка).
 */
@Injectable({
  providedIn: 'root',
})
export class PostsApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/posts';

  getAllPosts(filter?: IPostParams): Observable<IPostResponseModel> {
    return this.http.getWithHeaders(this.apiUrl, filter).pipe(
      map(res => ({
        items: res.body ?? [],
        total: Number(res.headers.get('X-Pagination-Total') ?? 0),
      })),
    );
  }

  getPostById(id: string): Observable<IPostItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  setPost(payload: IPostPayload): Observable<unknown> {
    return this.http.post(this.apiUrl, payload);
  }

  updatePostById(id: string, payload: IPostPayload): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deletePost(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }

  /** Привязать/перенести полосу к посту (ADR 0008, срез 02). */
  assignLane(postId: string, laneId: string): Observable<unknown> {
    return this.http.post(this.apiUrl + '/' + postId + '/lanes/' + laneId, {});
  }

  /** Вернуть полосу из поста в пул «полосы без поста» (OS2). */
  unassignLane(postId: string, laneId: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + postId + '/lanes/' + laneId);
  }
}
